import { Phone, ShoppingCart, Sparkles } from 'lucide-react';

import type { TemplateAr } from '../../template-data';

export const aiPhoneCallsForDeliveryNotificationsAr: TemplateAr = {
  name: 'مكالمات هاتفية بالذكاء الاصطناعي لإشعارات التوصيل',
  description:
    'مكالمات هاتفية آلية بالذكاء الاصطناعي تبلّغ العملاء بحالة التوصيل، وتجدول أوقاته، وتأكّد الاستلام.',
  category: 'المكالمات الهاتفية بالذكاء الاصطناعي',
  workflow: [
    { icon: ShoppingCart, label: 'الطلب جاهز' },
    { icon: Sparkles, label: 'الـ AI يتصل' },
    { icon: Phone, label: 'تأكيد التوصيل', final: true },
  ],
  detailDescription: {
    paragraph1:
      'خبّر عميلك بحالة توصيله قبل ما يسأل. الـ AI يتصل عشان يأكد أوقات التوصيل، وينبّه على التأخير، وينسّق موعداً محدداً، ويأكد التوصيل لمّا يوصل. ويتولّى التحقق من العنوان وتعليمات التوصيل الخاصة.',
    paragraph2:
      'تأكيدات التوصيل وتفضيلات الجدولة توصل لنظام اللوجستيات عندك، أو برنامج إدارة المستودعات، أو أدوات تتبّع الشحنات. والـ AI ينسّق مع فريق التوصيل لحظياً.',
  },
  benefits: [
    'محاولات التوصيل الفاشلة تنزل وتلاحظ الفرق',
    'الـ AI ينسّق أوقات التوصيل',
    'العنوان وتعليمات الدخول تتأكد بالمكالمة',
    'التأخير يوصل للعميل قبل ما يسأل عنه',
    'تجربة توصيل أفضل لعميلك',
    'فريق اللوجستيات يوفّر وقت التنسيق',
  ],
};
